import React from "react";
import Layout from "./Layout";

const Home = () => {
  return <Layout />;
};

export default Home;
